import React from 'react';
import { TimezoneEnum } from '@reach/shared-types/business-automation';

interface Timezone {
  iana: string;
  name: string;
  offset: string;
}

const TIMEZONES: Timezone[] = [
  { iana: 'America/Los_Angeles', name: 'Pacific', offset: 'UTC−8' },
  { iana: 'America/Denver', name: 'Mountain', offset: 'UTC−7' },
  { iana: 'America/Chicago', name: 'Central', offset: 'UTC−6' },
  { iana: 'America/New_York', name: 'Eastern', offset: 'UTC−5' },
];

const formatLabel = (tz: Timezone): string => {
  const city = tz.iana.split('/')[1].replace('_', ' ');
  return `${city} — ${tz.name} (${tz.offset})`;
};

interface TimezoneDropdownProps {
  value?: TimezoneEnum | string;
  onChange?: (value: TimezoneEnum) => void;
}

export function TimezoneDropdown({ value = TimezoneEnum.EST, onChange }: TimezoneDropdownProps) {
  const handleChange = (e: React.ChangeEvent<HTMLSelectElement>) => {
    if (onChange) {
      // Cast IANA string to TimezoneEnum - backend accepts IANA strings
      onChange(e.target.value as TimezoneEnum);
    }
  };

  // TimezoneEnum values are IANA strings, so we can use directly
  const ianaValue = (value as string) || TimezoneEnum.EST;

  return (
    <select
      value={ianaValue}
      onChange={handleChange}
      className="w-full p-2 border border-gray-300 rounded-md bg-white text-gray-800 focus:outline-none focus:ring-2 focus:ring-blue-500">
      {TIMEZONES.map(tz => (
        <option key={tz.iana} value={tz.iana}>
          {formatLabel(tz)}
        </option>
      ))}
    </select>
  );
}
